/* eslint-disable max-len */
import { motion } from 'framer-motion';
import React,{useEffect,useCallback,useState} from 'react'
import { connect } from 'react-redux'
import { DistributorActions } from '../../redux/actions/distributor.action';
import { distributorService } from '../../service/distributor.service';
import AddressSection from './AddressSection';
import AdorSupport from './AdorSupport';
import ProfileHeader from './ProfileHeader';
import ProfileSection from './ProfileSection';
import ProfileSkeleton from './ProfileSkeleton';
import './style.css';

export const Profile = ({Getprofile,Profile}) => {
    const [tabType, settabType] = useState('Profile');
    const [InitialLoad, setInitialLoad] = useState(true)
    const [addressList, setAddressList] = useState([])
    const handleFetch = useCallback((() => {
        Getprofile()
        distributorService.Getaddress().then((res)=>{
            if(!res.error && res.data.success_status){
                setAddressList(res?.data?.data.data)
            }
        })
        setTimeout(() => {
            setInitialLoad(false)
        }, 2000);        
    }), []);
    useEffect(() => {
        handleFetch();
    }, [handleFetch]);
    return (
        <motion.div                              
            className="md:px-[46px] px-4 mt-3.5">
            {Profile && Object.keys(Profile).length > 0 && Object.keys(Profile?.profile).length > 0 ? (
                <>
                    <ProfileHeader HeaderData={Profile?.profile} handleFetch={handleFetch}/>
                    <div className="lg:px-[68px] md:px-[48px] px-1 pt-[26px] pb-10">
                        <ul className="nav nav-pills flex sm:justify-start justify-between border-b border-[#FFFFFF]" id="pills-tab" role="tablist">
                            {['Profile','Addresses','Ador Support'].map((type)=>(
                                <motion.li
                                    initial={{ opacity: 0, scale: 1 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    className={`nav-item ${type !=='Profile' ? 'pl-8':''}`} role="presentation" key={type}>
                                    <p href="javascript:void(0)" 
                                        onClick={()=>settabType(type)}
                                        className={`cursor-pointer nav-link block sm:text-lg text-base font-normal text-[#555259] ${type ===tabType ? 'active':''} webprofile relative`} id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="true">
                                        {type}
                                    </p>
                                </motion.li>
                            ))}
                        
                        </ul>
                        <motion.div
                            animate={{ opacity: 1, y: 0 }}
                            initial={{ opacity: 0, y: 20 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.15 }}
                            key={tabType}
                            className="tab-content mb-10" id="pills-tabContent">
                            <ProfileSection type={tabType} Details={Profile?.profile} />
                            <AddressSection type={tabType} Details={Profile?.profile} addressList={addressList}/>
                            <AdorSupport type={tabType} Details={Profile?.profile}/>
                        
                        </motion.div>
                    </div>
                </>):<ProfileSkeleton />
            
            }
            
        
        </motion.div>
    )
}


const mapStateToProps = (state) => {
    const  { Profile } = state;
    return {Profile}

}

const mapDispatchToProps = {
    Getprofile:DistributorActions.GetprofileData
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile)